var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoArrowDownOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L5.24264 5.24264M8.4986 1L4.25595 5.24264",
    stroke: "white",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDownOn);
export default __webpack_public_path__ + "static/media/ico-arrow-down-on.5cd96919c065f9ae4b05df5f43ba7a58.svg";
export { ForwardRef as ReactComponent };